module.exports = __webpack_public_path__ + "media/Segment_20200914.7e5b31d7.mp4";